import classNames from 'classnames';
import { NumberFormatter } from 'components/shared/NumberFormatter/NumberFormatter';
import { SwitchWithLabel } from 'components/shared/Switch/Switch';
import { useAppSelector } from 'hooks/useAppSelector';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { FormIdProps } from 'shared/props';
import {
  missedDealFeedbackIsSgPositionningChanged,
  missedDealFeedbackNumberOfIssuersChanged,
  missedDealFeedbackSgPositionChanged,
} from 'state/missed-deal-feeedback/actions';
import {
  getFeedbackIsSgPositionning,
  getFeedbackNumberOfIssuers,
  getFeedbackNumberOfIssuersIsValid,
  getFeedbackSgPosition,
  getFeedbackSgPositionIsValid,
} from 'state/missed-deal-feeedback/selectors';
import styled from 'styled-components';

const SmallNumberFormatter = styled(NumberFormatter)`
  width: 3em !important;
`;

const StyledSwitchWithLabel = styled(SwitchWithLabel)`
  margin-bottom: 0 !important;

  label {
    margin-bottom: 0 !important;
  }
`;
export function SgPositioning({ formId }: FormIdProps) {
  const { formatMessage } = useIntl();
  const isSgPositionning = useAppSelector(state => getFeedbackIsSgPositionning(state, formId));
  const sgPosition = useAppSelector(state => getFeedbackSgPosition(state, formId));
  const numberOfIssuers = useAppSelector(state => getFeedbackNumberOfIssuers(state, formId));
  const sgPositionIsValid = useAppSelector(state => getFeedbackSgPositionIsValid(state, formId));
  const numberOfIssuersIsValid = useAppSelector(state => getFeedbackNumberOfIssuersIsValid(state, formId));
  const dispatch = useDispatch();

  return (
    <>
      <StyledSwitchWithLabel
        id="missedDealFeedback-sgpositionning"
        value={isSgPositionning}
        onToggleSwitch={v => dispatch(missedDealFeedbackIsSgPositionningChanged(formId, v))}
        label={formatMessage({ id: 'missedDealFeedback.sgPositioningBefore' })}
        colSize={10}
        isAlignedLeft
        wrapText
      />
      {isSgPositionning && (
        <div className="d-flex flex-row align-items-center gap-2">
          <SmallNumberFormatter
            className={classNames({
              'is-warning': !sgPositionIsValid,
            })}
            e2e="sg-position"
            incrementStep={1}
            precision={0}
            decimalPadding={false}
            isDisabled={false}
            isReadOnly={false}
            onChange={v => dispatch(missedDealFeedbackSgPositionChanged(formId, v))}
            value={sgPosition}
            hasError={false}
            max={numberOfIssuers}
          />
          <FormattedMessage id="missedDealFeedback.sgPositioningMiddle" />
          <SmallNumberFormatter
            className={classNames({
              'is-warning': !numberOfIssuersIsValid,
            })}
            e2e="number-of-issuers"
            incrementStep={1}
            precision={0}
            decimalPadding={false}
            isDisabled={false}
            isReadOnly={false}
            onChange={v => dispatch(missedDealFeedbackNumberOfIssuersChanged(formId, v))}
            value={numberOfIssuers}
            hasError={false}
          />
          <FormattedMessage id="missedDealFeedback.sgPositioningAfter" />
        </div>
      )}
    </>
  );
}
